import { apiSlice } from 'src/features/api/api-slice';
import { ApiResponse } from 'src/common/interfaces';

import { VoucherFormData, StripeBuyVouchersResponse, VoucherBasePrice } from './voucher.types';

export const vouchersApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    StripeBuyVouchers: builder.mutation<ApiResponse<StripeBuyVouchersResponse>, VoucherFormData>({
      query: (body: VoucherFormData) => ({
        url: 'payments/stripe/buy-vouchers',
        method: 'POST',
        body,
      }),
    }),
    getBasePrice: builder.query<ApiResponse<VoucherBasePrice>, void>({
      query: () => ({
        method: 'GET',
        url: 'payments/base-cost',
      }),
    }),
  }),
});

export const { useStripeBuyVouchersMutation, useGetBasePriceQuery } = vouchersApiSlice;
